import { usePaletteValues } from "@hooks/usePaletteValues";

export const ThemedRadialGradient = ({
  palette,
  size = Math.min(window.innerHeight, window.innerWidth) / 2,
}: {
  palette: string;
  size?: number;
}) => {
  const colors = usePaletteValues(palette);

  return (
    <div
      className="h-[max(100vh,100vw)] w-[max(100vh,100vw)] pointer-events-none"
      style={{
        background: `radial-gradient(
          circle,
          ${colors.deep(0.4)} ${size / 2}px,
          ${colors.deep(0)} ${size}px
        )`,
      }}
    />
  );
};
